<div class="modal-overlay" (click)="close()"></div>
<div class="modal-container">
    <form trapFocus [formGroup]="form">
        <div class="modal-header light-blue">
            <div class="container-fluid">
                <div class="row modal-header-row">
                    <div class="modal-icon icon fill-white" aria-label="logo" [inlineSVG]="'assets/ico/user-regular.svg'">
                    </div>
                    <span class="modal-title" id="modal-basic-title">{{'dashboard.persona.new.insertPersona' |
                        translate}}</span>
                    <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close" [inlineSVG]="'assets/ico/close-24px.svg'"></div>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="row my-4" [formGroup]="form">
                <div class="form-group col-lg-6">
                    <apc-form-input [class]="'form-control'" formControlName="firstName" [type]="'text'" [isRequired]="true">
                        <label label>{{'dashboard.persona.new.name' | translate}}</label>
                    </apc-form-input>
                </div>
                <div class="form-group col-lg-6">
                    <apc-form-input [class]="'form-control'" formControlName="firstSurname" [type]="'text'" [isRequired]="true">
                        <label label>{{'dashboard.persona.new.surname' | translate}}</label>
                    </apc-form-input>
                </div>
            </div>
        </div>
        <div class="modal-footer p-0">
            <div class="container-fluid my-3 px-3">
                <span *ngIf="!isSaved" class="btn modal-btn save" (click)="checkAndCreatePersona($event)">{{'buttons.create' | translate}} {{'buttons.persona' | translate }}</span>
                <span class="btn modal-btn save" (click)="clearAll()">{{'buttons.clearAll' | translate }}</span>
            </div>
        </div>
    </form>
</div>